<template>
    <div class="holiday_balance_wrap" v-loading="loading">
        <div class="page-filter_wrap">
            <div class="page-filter_wrap_left">
                <!-- <el-input
                    v-model="searchForm.keyWord"
                    class="filter-input"
                    clearable
                    placeholder="请输入员工姓名"
                    @clear="handleClickSearch"
                    @keyup.enter.native="handleClickSearch"
                >
                    <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                </el-input> -->
                <el-select
                    clearable
                    placeholder="请输入员工姓名"
                    size="small"
                    v-model="searchForm.uid"
                    collapse-tags
                    filterable
                    remote
                    :remote-method="getUserList"
                    @change="handleClickSearch"
                >
                    <el-option :key="user.uid" :label="user.name" :value="user.uid" v-for="user in userList">
                    </el-option>
                </el-select>
                <el-select
                    placeholder="请选择部门"
                    ref="department_select"
                    class="filter-input"
                    size="small"
                    v-model="searchForm.department"
                    :remote-method="getDepartmentList"
                    filterable
                    remote
                    reserve-keyword
                    clearable
                    @clear="handleClickClearDepartment"
                >
                    <el-option :value="searchForm.department" style="height: auto; padding: 0">
                        <el-tree
                            :data="departmentList"
                            :expand-on-click-node="false"
                            :props="{ children: 'children', label: 'relate_name' }"
                            @node-click="handleClickDepNode"
                            check-on-click-node
                            check-strictly
                            default-expand-all
                            node-key="id"
                            ref="depTree"
                        >
                        </el-tree>
                    </el-option>
                </el-select>
            </div>
            <div class="page-filter_wrap_right">
                <el-button size="small" @click="handleClickImport">导入</el-button>
                <el-button
                    type="primary"
                    size="small"
                    :loading="exportBtnDisabled"
                    :disabled="exportBtnDisabled"
                    @click="handleClickExport"
                    >导出</el-button
                >
            </div>
        </div>
        <div class="page-content">
            <CustomVxeTable
                ref="tableRef"
                :empty-render="{ name: 'NotData' }"
                :isShowToolBar="false"
                :pagination.sync="pagination"
                :reduceHeight="reduceHeight"
                :tableData="tableData"
                @handleCurrentChange="handleCurrentChange"
                @handleSizeChange="handleSizeChange"
                @selection-change="selectionChange"
                id="holidayBalanceTable"
            >
                <vxe-column field="user_name" title="姓名" fixed="left" width="150">
                    <template #default="{ row }">
                        <span>{{ row.user_name || "--" }}</span>
                    </template>
                </vxe-column>
                <vxe-column field="department_name" title="部门" min-width="130">
                    <template #default="{ row }">
                        <el-tooltip
                            :content="row.department_path ? row.department_path : row.department_name"
                            effect="dark"
                            placement="top-start"
                            v-if="row.department_name"
                        >
                            <span v-text="row.department_name"></span>
                        </el-tooltip>
                        <span v-else>--</span>
                    </template>
                </vxe-column>
                <vxe-column field="joined_date" title="入职时间" min-width="96">
                    <template #default="{ row }">
                        <span>{{ row.joined_date || "--" }}</span>
                    </template>
                </vxe-column>
                <vxe-column v-for="(item, index) in fieldsList" :title="item.field_name" :field="item.field_key" header-align="right">
                    <template #header>
                        <div class="table_field_label">
                            <span v-text="item.name"></span>
                            <span class="batch_icon" @click="handleClickBatchEdit(item)"
                                ><i class="iconfont icon-piliangbianji"></i
                            ></span>
                        </div>
                    </template>
                    <template #default="{ row }">
                        <div>
                            <el-tooltip
                                effect="dark"
                                placement="top"
                                :key="index"
                                :disabled="!row.recent_edit.length"
                                popper-class="custom-table_list_tooltip"
                            >
                                <div slot="content" v-if="row.recent_edit && row.recent_edit.length" style="line-height: 22px; font-size: 14px;color: #ffffff;">
                                    <p>假期余额来源</p>
                                    <p v-for="(recentItem, recentIndex) in row.recent_edit">{{ recentItem.remark }}</p>
                                </div>
                                <el-input
                                    class="custom-table_input"
                                    v-model="row['holiday_config_id_' + item.holiday_config_id]"
                                    @blur="handleBlur(item.holiday_config_id, row, $event)"
                                ></el-input>
                            </el-tooltip>
                        </div>
                    </template>
                </vxe-column>
                <template #empty>
                    <div class="custom-table-empty">
                        <div class="custom-table-empty-img">
                            <img src="https://download.hecoos.com/enlightv/2025-09/79aca5659d09f1a8f1161d7106c3ecf6.png" alt="">
                        </div>
                        <p class="custom-table-empty-txt">暂无数据</p>
                    </div>
                </template>
            </CustomVxeTable>
        </div>
        <AttendanceHolidayBalanceBatch
            :holidayBalanceBatchDialogVisible.sync="holidayBalanceBatchDialogVisible"
            :all_uids="all_uids"
            :holiday_id="holiday_id"
            @callbackSuccess="handleClickSearch"
            v-if="holidayBalanceBatchDialogVisible"
        />
    </div>
</template>

<script>
import * as XLSX from "xlsx";
import { GetDepartmentList, GetHolidayBalanceList, UpdateHolidayBalance, GetUserList } from "@/api";
import { pagination } from "@/mixins";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import AttendanceHolidayBalanceBatch from "./component/attendance_holiday_balance_batch.vue";
export default {
    name: "HolidayBalance",
    components: { CustomVxeTable, AttendanceHolidayBalanceBatch },
    data() {
        return {
            searchForm: {
                keyWord: "",
                uid: "",
                department: "",
            },
            departmentList: [],
            loading: false,
            tableData: [],
            fieldsList: [], // 自定义表头字段
            all_uids: [], // 用户id
            reduceHeight: 220,
            holidayBalanceBatchDialogVisible: false,
            holiday_id: "", //假期config_id
            exportBtnDisabled: false,
            userList: []
        };
    },
    mixins: [pagination],
    created() {
        this.getDepartmentList();
        this.getTableData();
    },
    methods: {
        // 部门数据
        getDepartmentList() {
            GetDepartmentList().then((res) => {
                if (res.code === 200) {
                    this.departmentList = res.data || [];
                }
            });
        },
        // 部门选择
        handleClickDepNode(data, node, nodeData) {
            this.searchForm.department = data.relate_name;
            this.searchForm.department_id = data.relate_id;
            this.$refs.department_select.handleClose();
            this.handleClickSearch();
        },
        // 清空部门选择
        handleClickClearDepartment() {
            this.searchForm.department_id = "";
            this.handleClickSearch();
        },
        handleBlur(holiday_id, row, event) {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
                this.submitData(holiday_id, row, event);
            }, 300);
        },
        // 值改变
        submitData(holiday_id, row, event) {
            const params = {
                all_uids: [row.user_id],
                type: "single", // single单次 ,batch批量 决定是否记录日志
                holiday_id,
                new_balance: event.target && event.target.value ? Number(event.target.value) : "",
            };
            const origin_value = row['holiday_config_id_' + holiday_id + '_origin']
            if (params.new_balance !== null && params.new_balance !== "" && params.new_balance !== origin_value) {
                row.loading = true
                UpdateHolidayBalance(params)
                    .then((res) => {
                        if (res.code === 200) {
                            row.loading = false;

                            this.$message({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {},
                            });
                        }
                        this.getTableData()
                    })
                    .catch(() => {
                        // this.getTableData()
                    });
            }
        },
        // 让所有的input失去焦点
        removeFocusFromInputs() {
            // 获取所有的input元素
            const inputs = document.querySelectorAll(".custom-table_input input");
            // 遍历并失去焦点
            inputs.forEach((input) => input.blur());
        },
        // 搜索
        handleClickSearch() {
            this.pagination.pageNum = 1;
            this.getTableData();
        },
        // 导入
        handleClickImport() {
            this.$router.push({
                name: "HolidayBalanceImport",
                params: {
                    pageSize: this.pagination.total,
                    department_id: this.searchForm.department_id,
                    uid: this.searchForm.uid,
                },
            });
        },
        // 批量更改
        handleClickBatchEdit(item) {
            this.holiday_id = item.holiday_config_id;
            this.holidayBalanceBatchDialogVisible = true;
        },
        // 表格复选框
        selectionChange(ids) {},
        // 页码改变
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.getTableData();
        },
        // 页数改变
        handleSizeChange(page) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = page.pageSize;
            this.getTableData();
        },
        getTableData() {
            this.loading = true;
            let params = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
            };
            if (this.searchForm.uid !== "") {
                params.uid = this.searchForm.uid;
            }
            if (this.searchForm.department_id !== "") {
                params.department_id = this.searchForm.department_id;
            }
            GetHolidayBalanceList(params)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total, header, all_uids } = res.data;
                        let tableData = data || [];
                        tableData.forEach((item) => {
                            if (item.holiday_balances && item.holiday_balances.length) {
                                item.holiday_balances.forEach((childItem) => {
                                    this.$set(
                                        item,
                                        "holiday_config_id_" + childItem.holiday_config_id,
                                        childItem.balance
                                    );
                                    // 保存初始化数据，在更新的时候做比较
                                    this.$set(
                                        item,
                                        "holiday_config_id_" + childItem.holiday_config_id + '_origin',
                                        childItem.balance
                                    )
                                });
                            }
                        });
                        this.tableData = tableData;
                        this.fieldsList = header || [];
                        this.all_uids = all_uids || [];
                        this.pagination.total = total;
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 获取人员
        getUserList(keyword) {
            GetUserList({ keyword }).then((res) => {
                if (res.code == 200) {
                    this.userList = res.data || [];
                }
            });
        },
        // 导出
        handleClickExport() {
            this.exportBtnDisabled = true;
            let tableData = [];
            let headers = [
                { field_key: "user_name", field_name: "姓名" },
                { field_key: "phone", field_name: "手机号" },
                { field_key: "department_name", field_name: "部门" },
                { field_key: "joined_date", field_name: "入职时间" },
            ];
            let HeaderInfo = [];
            let params = {
                page: 1,
                pageSize: this.pagination.total,
            };
            if (this.searchForm.uid !== "") {
                params.uid = this.searchForm.uid;
            }
            if (this.searchForm.department_id !== "") {
                params.department_id = this.searchForm.department_id;
            }
            GetHolidayBalanceList(params)
                .then((res) => {
                    if (res.code === 200) {
                        const { data, header, total } = res.data;
                        header.forEach((item) => {
                            headers.push({
                                field_key: "holiday_config_id" + item.holiday_config_id,
                                field_name: item.name,
                                field_type: "holiday_config_id",
                                holiday_config_id: item.holiday_config_id,
                            });
                        });
                        HeaderInfo = headers.map((item) => item.field_name);
                        tableData = data.map((item) => {
                            let itemdata = [];
                            headers.forEach((field) => {
                                if (field.field_type) {
                                    // 自定义字段
                                    const find_item = item.holiday_balances.find(
                                        (item) => item.holiday_config_id === field.holiday_config_id
                                    );
                                    itemdata.push(find_item ? find_item.balance : "");
                                } else {
                                    // 固定字段
                                    if(field.field_key == 'department_name') {
                                        itemdata.push(item.department_path ? item.department_path : item.department_name)
                                    } else {
                                        itemdata.push(item[field.field_key]);
                                    }
                                }
                            });
                            return itemdata;
                        });
                        // 数据结构
                        // const data = [
                        //     ["姓名", "年龄"],
                        //     ["刘XX", 1],
                        // ];
                        const xlsxData = [HeaderInfo, ...tableData];
                        const ws = XLSX.utils.aoa_to_sheet(xlsxData);
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
                        const fileName = this.nowDate();
                        setTimeout(() => {
                            XLSX.writeFile(wb, fileName);
                            this.$message.success("导出成功");
                        }, 2000);
                    }
                    this.exportBtnDisabled = false;
                })
                .catch(() => {
                    this.exportBtnDisabled = false;
                });
        },
        nowDate(type) {
            const today = new Date();
            const year = today.getFullYear();
            let month = today.getMonth() + 1;
            month = month < 10 ? "0" + month : month;
            const date = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
            const hours = today.getHours();
            const minutes = today.getMinutes();
            const seconds = today.getSeconds() < 10 ? "0" + today.getSeconds() : today.getSeconds();
            if (type && type == "date") {
                return `${year}-${month}-${date}`;
            } else if (type && type == "date2") {
                return `${year}-${month}`;
            } else {
                return `员工假期余额${year}年${month}月${date}日${hours}时${minutes}分${seconds}秒.xlsx`;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.holiday_balance_wrap {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    .page-filter_wrap {
        padding: 16px 16px 0;
        .page-filter_wrap_left {
            align-items: center;
            & > .el-input,
            & > .el-select,
            & > .el-date-editor {
                width: 238px;
                ::v-deep .el-input__inner {
                    height: 32px;
                    line-height: 32px;
                }
            }
            & > .el-checkbox {
                ::v-deep .el-checkbox__label {
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(102, 102, 102, 1);
                }
                &.is-checked {
                    ::v-deep .el-checkbox__label {
                        color: rgba(41, 144, 255, 1);
                    }
                }
            }
        }
    }
    .page-content {
        padding: 0 16px 16px;
        flex: 1;
        overflow-y: auto;
        .vxe-table {
            .batch_icon {
                display: inline-block;
                width: 22px;
                height: 22px;
                border-radius: 4px;
                text-align: center;
                line-height: 22px;
                color: #666666;
                cursor: pointer;
                &:hover {
                    background: rgba(0, 0, 0, 0.04);
                    color: rgba(51, 51, 51, 1);
                }
                &:active {
                    background: rgba(0, 0, 0, 0.04);
                }
            }
            .custom-table_input {
                border: none;
                width: 100%;
                ::v-deep {
                    .el-input__inner {
                        border: none;
                        background-color: transparent;
                        text-align: right;
                    }
                }
            }
            tr:hover {
                .custom-table_input {
                    background-color: transparent;
                }
            }
        }
    }
}
</style>
<style lang="scss">
.custom-table_list_tooltip {
    width: 330px !important;
    max-width: 330px !important;
    max-height: 320px !important;
    overflow-y: auto;
}
</style>
